// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__17-8q","footer":"ModalCreateQualiphyProcedure_footer__3yDK_","additionData":"ModalCreateQualiphyProcedure_additionData__28Ytr"};